import { Chapter } from '@/types/types';
import { PlayIcon } from '@heroicons/react/24/solid';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/Button';
import { useChapterStore } from '@/pages/mission/shared/store/useChapterStore';
import ChapterCard from '@/components/Card/Chapter';
import { Maybe, Trait } from '@edwin-group/cj-graphql';

export const Card = ({
  chapter,
  missionSlug,
  chapterId,
  index,
  trait,
  totalChapters,
  showBookmarkIcon,
  buttonText,
  onRemoveFromBookmark,
}: {
  chapter: Chapter;
  missionSlug: string;
  chapterId: string;
  index: number;
  trait?: string | Maybe<Trait> | undefined;
  totalChapters: number;
  showBookmarkIcon?: boolean;
  onRemoveFromBookmark?: () => void;
  buttonText?: string;
}) => {
  const navigate = useNavigate();
  const chapterPage = useChapterStore((state) => state.chapterPage);

  const onPressPlay = () => {
    if (chapter) {
      const encodedTitle = encodeURIComponent(chapter?.title || '');
      navigate(`/mission/${missionSlug}/chapter/${encodedTitle}`);
    }
  };

  return (
    <ChapterCard
      onRemoveFromBookmark={onRemoveFromBookmark}
      chapterId={chapterId}
      showBookmarkIcon={showBookmarkIcon}
      index={index}
      trait={trait}
      totalChapters={totalChapters}
      chapter={chapter}
      button={
        <Button onClick={onPressPlay} theme={'solid-primary-600'} size="default" className="self-start">
          <PlayIcon className=" h-5 w-5 !text-secondary-700" />
          {buttonText || chapterPage?.nextPart}
        </Button>
      }
    />
  );
};
